import React, { useState } from 'react';

const TECH_CATEGORIES = [
  {
    id: 'frontend',
    label: 'Frontend',
    items: [
      {
        name: 'Angular',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg'
      },
      {
        name: 'Jetpack Compose',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg'
      },
      {
        name: 'React Native',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'
      },
      {
        name: 'SwiftUI',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg'
      },
      {
        name: 'Vuejs',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg'
      }
    ]
  },
  {
    id: 'backend',
    label: 'Backend & Database',
    items: [
      {
        name: 'Node.js',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg'
      },
      {
        name: 'Python',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg'
      },
      {
        name: 'MongoDB',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg'
      },
      {
        name: 'PostgreSQL',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg'
      },
      {
        name: 'MySQL',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg'
      }
    ]
  },
  {
    id: 'native',
    label: 'Native App',
    items: [
      {
        name: 'Android / Kotlin',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg'
      },
      {
        name: 'iOS / Swift',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg'
      },
      {
        name: 'Java',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg'
      },
      {
        name: 'Objective-C',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/objectivec/objectivec-plain.svg'
      }
    ]
  },
  {
    id: 'crossplatform',
    label: 'Cross-Platform',
    items: [
      {
        name: 'Flutter',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg'
      },
      {
        name: 'React Native',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'
      },
      {
        name: 'Ionic',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ionic/ionic-original.svg'
      }
    ]
  },
  {
    id: 'cloud',
    label: 'Cloud & DevOps',
    items: [
      {
        name: 'AWS',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg'
      },
      {
        name: 'Docker',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg'
      },
      {
        name: 'Kubernetes',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg'
      },
      {
        name: 'Google Cloud',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg'
      }
    ]
  },
  {
    id: 'apis',
    label: 'APIs',
    items: [
      {
        name: 'GraphQL',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg'
      },
      {
        name: 'REST API',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg'
      },
      {
        name: 'gRPC',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/go/go-original.svg'
      }
    ]
  }
];

function TechStackSection() {
  const [activeTab, setActiveTab] = useState('frontend');

  const currentCategory = TECH_CATEGORIES.find((cat) => cat.id === activeTab) || TECH_CATEGORIES[0];

  return (
    <section className="tech-stack-section">
      <div className="container tech-stack-container">
        
        {/* Section Header */}
        <div className="tech-stack-header">
          <div className="tech-stack-title-box">
            <h2 className="tech-stack-title-main">
              Our Next-Gen<br />
              <span className="tech-stack-title-red">Technology Stack</span>
            </h2>
          </div>
          
          <div className="tech-stack-desc-box">
            <p className="tech-stack-desc">
              As an innovative Android app development agency that strives for the enhancement of app solutions, we utilize the latest technologies to create your business applications. Here is the diverse tech stack that our Android app developers and designers leverage to build state-of-the-art applications:
            </p>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="tech-stack-tabs-wrapper">
          <div className="tech-stack-tabs">
            {TECH_CATEGORIES.map((category) => (
              <button
                key={category.id}
                className={`tech-tab-btn ${activeTab === category.id ? 'active' : ''}`}
                onClick={() => setActiveTab(category.id)}
              >
                {category.label}
              </button>
            ))}
          </div>
          <div className="tech-stack-tabs-border"></div>
        </div>

        {/* Logos Grid Display */}
        <div className="tech-stack-grid">
          {currentCategory.items.map((item, index) => (
            <div key={index} className="tech-card">
              <div className="tech-logo-wrapper">
                <img
                  src={item.logo}
                  alt={item.name}
                  className="tech-logo-img"
                />
              </div>
              <span className="tech-name">{item.name}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default TechStackSection;
